import script from "./milestone-progress-reports.view.vue?vue&type=script&lang=ts&setup=true"
export * from "./milestone-progress-reports.view.vue?vue&type=script&lang=ts&setup=true"

import "./milestone-progress-reports.view.vue?vue&type=style&index=0&id=0aeaf7e5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aeaf7e5"]])

export default __exports__